import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import styles from 'src/components/Tile/TileJobName.scss';


const TileJobName = function ({ isHighlighted, job }) {
  const headerClassList = classNames(styles.header, {
    [styles['header--highlighted']]: isHighlighted
  });

  return <h3 className={ headerClassList }>{job}</h3>;
};

TileJobName.propTypes = {
  isHighlighted: PropTypes.bool.isRequired,
  job: PropTypes.string.isRequired
};

export default TileJobName;
